import React, { useEffect, useState } from "react";
import { Grid, Typography, Button, Paper, CardContent, Box, Card, Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import StartImage from "../../assets/IFW_SoftwarePAGE1ONLY-02.png";
import BlueBackground from "../../assets/IFW_SoftwarePAGE1ONLY-04.png";
import tomasHegnaPhoto from "../../assets/Tom Hegna.jpg"
import { firstLetterUpperCase } from "../../shared/first-letter-upper";

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { getClient } from "../../shared/api";
import { ACTION_SET_CURRENTCLIENT, } from "../../shared/constants";
import { removeSpaces } from "../../shared/shared";
import { useModal } from '../../hooks/useModal';
import { VideoModalTomHegna } from "../video-modal-tom";

const PresentationInfoPage = (props) => {
  const [userName, setUserName] = useState("");
  const [fpName, setFpName] = useState("");
  const dispatch = useDispatch();
  const { isOpen, openModal, closeModal, message } = useModal();
  const ifwUsers = useSelector((state) =>
      state.dataStore.getIn(["ifwUsers"])
  ).toJS();

  useEffect(() => {
    getClient(props.clientId, props.token).then((value) => {
      dispatch({
        type: ACTION_SET_CURRENTCLIENT,
        value: value.data
      });
      setUserName(firstLetterUpperCase(value.data.client.firstName));
      const fp = ifwUsers.filter(item => item.id === value.data.advisorId);
      if (fp.length > 0) {
        setFpName(`${fp[0].firstName} ${fp[0].lastName}`);
      }
    })
  }, [])

  const startImageStyle = {
    backgroundImage: `url("${BlueBackground}")`,
    height: '30%'
  };

  return (
    <React.Fragment>
    <Grid style={{ display: 'flex', flexDirection: 'row', height: '64vh' }} >
      <img
        src={StartImage}
        alt={"Start"}
        title={"Start"}
        style={{ width: '50%', objectFit: 'fill' }}
      />


      <Grid container style={{ display: 'flex', flexDirection: 'column', width: '50%' }} >

        <div style={startImageStyle} className={"presentation-start-image"}>
          <Typography style={{ fontSize: '20px', color: 'white', textAlign: 'center' }}>
            {`${removeSpaces(userName)}, Welcome to Your`}
          </Typography>
          <Typography style={{ fontSize: '20px', color: 'white', textAlign: 'center' }}>
            INSTITUTE OF FINANCIAL WELLNESS
          </Typography>
          <Typography style={{ fontSize: '20px', color: 'white', textAlign: 'center' }}>
            Retirement Roadmap Experience!
          </Typography>
        </div>


        <Grid className={"bottom-left-bar"} height={'50%'}>

          <Typography
            className={"never-say-never"}

            style={{ fontSize: '1em !important' }}
          >
            When It Comes To Financial Decisions; <br /> Never Say "Never", Never says "Always" ...It Depends!
          </Typography>



          <a
            style={{ color: '#157ee8', fontSize: '22px', textDecoration: 'underline' }}
            onClick={openModal}
            target={"_blank"}
          >
            {"Click to Watch Tom Hegna's Welcome Video"}
          </a>

          <Card className={'Tom-Hegna-Card'} >
            <CardContent >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div backgroundColor={'blue'} style={{ marginRight: '10px' }}>
                  <img src={`${tomasHegnaPhoto}`} height={'90px'} />
                  <Typography
                    sx={{ fontSize: 12 }}
                    display={'flex'}
                    color="text.secondary"
                    justifyContent={'center'}
                    gutterBottom
                  >Tom Hegna </Typography>
                </div>
                <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'} >
                  <ul>
                    <li> Best Selling Author </li>
                    <li> Renowned Global Retirement Spokesperson</li>
                    <li> 30+ Years Veteran Fortune 100 Executive in Retirement Planning</li>
                    <li> Non-Client Paid Endorser</li>
                  </ul>
                </Grid>
              </div>
            </CardContent>
          </Card>

        </Grid>
      </Grid>

      <VideoModalTomHegna isOpen={isOpen} closeModal={closeModal} />

      <Grid item xs={12} className={"plan-inputs-footer full-width"}>
        <Grid container spacing={3}>
          <Grid item xs={6} className={"left-button"}></Grid>
          <Grid item xs={6} className={"right-button"}>
            <Button
                onClick={props.next}
            >
              Get Started
              <ArrowRightIcon style={{ fontSize: "20px", padding: '0', margin: '0' }} />
            </Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid >

      <Grid container style={{ display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'center', backgroundColor: 'white', marginTop: '10px' }} >
        Prepared by {fpName}
      </Grid>
    </React.Fragment>
  );
};

export default PresentationInfoPage;
